export const getApiQuery = (params = {}) =>
  Object.keys(params)
    .filter((param) => !!params[param]) // exclude keys with undefined value
    .map((key) => `${key}=${encodeURIComponent(params[key])}`)
    .join('&');
